import React, {useEffect, useRef, useState} from "react";
import {shallowEqual, useSelector} from "react-redux";
import Portal from "../../../components/portal";
import {FiCheck, FiX} from "react-icons/fi";
import EnigooButton from "../../../MyComponent/EnigooButton";
import CogoToast from "cogo-toast";
import {apiDeleteUser} from "./Actions";
import {useParams} from "react-router";
import {useHistory} from "react-router-dom";
import {Form} from "react-final-form";
import {EnigooSelect} from "../../../MyComponent/EnigooSelect";
import {Trans, useTranslation} from "react-i18next";
import {_at} from "../../../MyComponent/AT";

export const UserExportModal = ({
                                    setOpen,
                                    open,
                                    onSave
                                }) => {
    let [saving, setSaving] = useState(false);
    const {palettes, actualAction} = useSelector(
        (state) => ({
            palettes: state.reducerAdmin.palettes,
            actualAction: state.reducerAdmin.actualAction,
            filterUser: state.reducerAdmin.filterUser
        }),
        shallowEqual
    )
    let {background} = {
        ...palettes
    }
    const modalRef = useRef(null)

    const hide = () => {
        setOpen(false);
    }

    const {t} = useTranslation()

    const history = useHistory();

    const exportUser = (values) => {
        onSave(values.type);
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!modalRef || !modalRef.current) return false
            if (!open || modalRef.current.contains(event.target)) {
                return false
            }
            setOpen(!open);
        }
        document.addEventListener('mousedown', handleClickOutside)

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [open, modalRef])

    return (
        <>
            {open && (
                <Portal selector="#portal">
                    <div className="modal-backdrop fade-in"></div>
                    <div className={`modal show ${background === 'dark' ? 'dark-mode' : ''}`}
                         data-background={background}>
                        <div className="relative min-w-sm w-1/3 mx-auto lg:max-w-5xl" ref={modalRef}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h3 className="text-xl font-semibold">{"Export akreditace"}</h3>
                                    <button
                                        className="modal-close btn btn-transparent"
                                        onClick={hide}>
                                        <FiX size={18} className="stroke-current"/>
                                    </button>
                                </div>
                                <Form initialValues={{type: 1}} onSubmit={exportUser}
                                      validate={(values) => {
                                          let error = {};
                                          if (!values.type) {
                                              error.type = _at("Vyberte typ exportu");
                                          }
                                          return error;
                                      }}
                                      render={({handleSubmit}) => (
                                          <>
                                              <div className={"max-h-sm overflow-y-scroll p-2 pb-10"}>

                                                  <div className={"m-2"}>
                                                      <EnigooSelect inModal={true}
                                                                    items={[{
                                                                        "id": 1,
                                                                        "name": _at("Export s názvem obrázků")
                                                                    }, {
                                                                        "id": 2,
                                                                        "name": _at("Export s náhledem obrázků")
                                                                    }]}
                                                                    name={"type"}
                                                                    label={_at("Jak chcete exportovat?") + ": *"}
                                                                    isClearable={false}/>
                                                  </div>

                                              </div>

                                              <div className="modal-footer space-x-2">
                                                  <EnigooButton disabled={saving} loading={saving} color={"red"}
                                                                onClick={hide}
                                                                text={_at("Zavřít")}
                                                                icon={<FiX/>}/>
                                                  <EnigooButton disabled={saving} loading={saving}
                                                                onClick={handleSubmit}
                                                                text={_at("Exportovat")} icon={<FiCheck/>}/>
                                              </div>
                                          </>
                                      )}/>
                            </div>
                        </div>
                    </div>
                </Portal>
            )}
        </>
    )
}
